<template>
    <div>
        <Header title="评价" type="0" route="/processEvaluation/index"></Header>
        <div class="conten">
            <p>教师:{{ this.dataList.jsxm }}</p>
            <p>学院:{{ this.dataList.dwmc }}</p>
            <p>课程:{{ this.dataList.kcmc }}</p>
            <p>学时:{{ this.dataList.zxs }}</p>
            <p>节次:{{ this.dataList.kcsj }}</p>
        </div>
        <div class="zongti" v-if="this.ztpjFlag">
            <span>总体评价</span>
            <div class="box">
                <div class="ztleft">
                    <van-form validate-first>
                        <van-radio-group v-model="radio">
                            <van-radio v-for="(item, index) in ztpjData" :key="item.id" :name="item.id" :disabled="dataList.sfpj != 0" @click="clearNum(index, item.id)">
                                {{ item.mx }}({{ item.qsfz }}-{{ item.jsfz }}分)
                                <van-field :rules="[{ validator, message: '请输入指定范围的分数' }]" v-model="ztpjData[index].number" :disabled="dataList.sfpj != 0" @input="shuru(index, item.qsfz, item.jsfz, ztpjData)" />
                            </van-radio>
                        </van-radio-group>
                    </van-form>
                </div>
            </div>
        </div>
        <div class="xijie">
            <template v-if="this.xjpjData === []">
                <span>细节评价</span>
                <div class="xjinfo" v-for="(xjitem, xjindex) in xjpjData" :key="xjindex">
                    <p>评价项目:{{ xjitem.pjxmmc }}</p>
                    <p>评价指标:{{ xjitem.pjzbmc }}</p>
                    <p>分值:{{ xjitem.fz }}</p>
                    <template v-if="xjitem.pjfslist[xjindex].pjfscode === '1'">
                        <p>评价方式:</p>
                        <van-radio-group v-model="modelList[xjindex]" v-for="(item, index2) in xjitem.pjfslist" :disabled="dataList.type != 'pj'" :key="index2">
                            <van-radio :name="item.id" @click="choise(item, xjitem, item.id)">
                                {{ item.xxmc }}
                            </van-radio>
                        </van-radio-group>
                    </template>
                    <template v-else-if="xjitem.pjfslist[xjindex].pjfscode === '2'" :disabled="dataList.type != 'pj'">
                        <van-field v-model="xjitem.value" label="评价方式" placeholder="请输入" input-align="right" colon @blur="shuruzhi(xjitem.fz, xjitem.value)" />
                    </template>
                </div>
            </template>
            <template v-else>
                <span>细节评价</span>
                <div class="xjinfo" v-for="(xjitem, xjindex) in xjpjData" :key="xjindex">
                    <p>评价项目:{{ xjitem.pjxmmc }}</p>
                    <p>评价指标:{{ xjitem.pjzbmc }}</p>
                    <p>分值:{{ xjitem.fz }}</p>
                    <template v-if="xjitem.pjfslist[xjindex].pjfscode === '1'">
                        <p>评价方式:</p>
                        <van-radio-group v-model="modelList[xjindex]" v-for="(item, index2) in xjitem.pjfslist" :disabled="dataList.type != 'pj'" :key="index2">
                            <van-radio :name="item.id" @click="choise(item, xjitem, item.id)">
                                {{ item.xxmc }}
                            </van-radio>
                        </van-radio-group>
                    </template>
                    <template v-else-if="xjitem.pjfslist[xjindex].pjfscode === '2'" :disabled="dataList.type != 'pj'">
                        <van-field v-model="xjitem.value" label="评价方式" placeholder="请输入" input-align="right" colon @blur="shuruzhi(xjitem.fz, xjitem.value)" />
                    </template>
                </div>
            </template>
        </div>
        <div class="tongji">
            <span>统计</span>
            <div class="zonghe">
                <span v-if="this.ztpjFlag">总体评分:{{ this.total }}</span>
                <span v-if="this.xjpjData != []">细节评价评分:{{ numresult }}</span>
                <!-- <span>细节评价评分:{{ this.ztpjData === [] ? (this.result + this.choiseResult) : this.tjxjpjpf }}</span> -->
            </div>
        </div>
        <div class="yijian">
            <span>主观评价意见</span>
            <van-field rows="3" autosize :disabled="dataList.type != 'pj'" :label="item.nr" v-model="item.dpjnr" type="textarea" v-for="(item, idx) in zgpjdata" :key="idx" />
        </div>
        <div class="bottomButton">
            <button v-if="+dataList.sfpj === 0" type="primary" style="background-color: #7469f8" @click="submit()">
                提交
            </button>
        </div>
    </div>
</template>

<script>
import { Api } from '@/utils/axios';
import { Toast } from 'vant';
export default {
    data() {
        return {
            dataList: '',
            radio: '',
            ztpjValue: '',
            text: '123',
            ztpjData: [],
            xjpjData: [],
            xjradio: '',
            test: '',
            max: '',
            min: '',
            total: '',
            tjxjpjpf: 0,
            result: '',
            choiseResult: '',
            zgpjdata: [],
            flId: '',
            modelList: [],
            fsList: {},
            numresult: 0,
            ztpjFlag: true
        };
    },
    // beforeRouteLeave(to, from, next) {
    //     to.meta.keepAlive = true;
    //     next();
    // },
    created() {
        this.dataList = this.$route.query.item;
        this.flId = this.$route.query.pjflId;
        this.getxsgcpjXq();
    },
    methods: {
        //评价问题接口
        async getxsgcpjXq() {
            const params = {
                type: this.dataList.type,
                pjflid: this.flId,
                pjjgid: this.dataList.pjjgid
            };
            const res = await Api.getxsgcpjXq(params);
            this.ztpjData = res.data.ztpjdata;
            this.xjpjData = res.data.xjpjdata.pjzb;
            this.zgpjdata = res.data.zgpjdata;
            if (!res.data.ztpjdata || res.data.ztpjdata.length == 0) {
                this.ztpjFlag = false;
            }
            const fsList = {};
            res.data.xjpjdata.pjzb.forEach((list, index) => {
                const fz = list.fz;
                list.pjfslist.forEach((item) => {
                    let key = index + '-' + item.id;
                    fsList[key] = (parseInt(item.xxqz) / 100) * parseInt(fz);
                });
            });
            this.fsList = fsList;
            // this.modelList =  res.data.pjjgdata.xjpj.map((item) => item.pjzbid || item.xxszid)
            this.modelList = res.data.pjjgdata.xjpj.map((item) => item.xxszid);
            this.getFsResult();
            if (res.data.pjjgdata !== []) {
                res.data.pjjgdata.ztpj.forEach((item, index) => {
                    this.radio = item.xxpjid;
                    if (this.ztpjFlag == true) {
                        this.ztpjData[index].number = item.zpf;
                    }
                    this.total = item.zpf;
                });
                // res.data.pjjgdata.xjpj.forEach((item, index) => {
                //   this.modelList[index] = item.xxszid
                //   this.tjxjpjpf += parseInt(item.fz)
                // })
                res.data.pjjgdata.zgpj.forEach((item, index) => {
                    this.zgpjdata[index].dpjnr = item.zgnr;
                });
            }
        },
        //评价问题判断值范围
        validator(val) {
            console.log('val:', val);
            if (parseInt(val) < this.min || parseInt(val) > this.max) {
                return false;
            }
            return true;
        },
        //输入框
        shuru(name, min, max, value) {
            this.max = max;
            this.min = min;
            this.total = value[name].number;
        },
        //输入值校验提示
        shuruzhi(fz, val) {
            if (parseInt(val) > parseInt(fz)) {
                Toast.fail('评分值不能大于' + fz);
            } else {
                this.result = (parseInt(fz) / 100) * parseInt(val);
            }
        },
        //  清空输入框
        clearNum(index1, id) {
            this.ztpjData.forEach((item, index2) => {
                if (index2 !== index1) {
                    if (item.number !== undefined) {
                        item.number = '';
                        item.value = '';
                        this.total = '';
                    }
                }
            });
            //
            this.ztpjData[index1].value = id;
        },
        getFsResult() {
            let num = 0;
            this.modelList.forEach((item, index) => {
                let key = index + '-' + item;
                console.log('key: ', key);
                if (!this.fsList[key]) return;
                console.log('ssssssssssss');
                num += this.fsList[key];
            });
            this.numresult = num;
            console.log('num:合计num就是选中的合计 ', num);
        },
        //选择题
        choise(item, xjitem, id) {
            console.log('modelList: ', {
                modelList: this.modelList,
                xjpjData: this.xjpjData,
                fsList: this.fsList,
                id
            });
            xjitem.value = item.id;
            this.getFsResult();
            //  this.choiseResult = parseInt(xxqz)/100 * parseInt(fz);
            //  this.xjpjData.forEach(item => {
            //    item.pjfslist.forEach(item2 => {
            //      if (id === item2.id) {
            //        item.value = id
            //      }
            //    })
            //  })

            //  this. xjitem.pjfslist.forEach((item))
        },
        //提交
        async submit() {
            console.log('submit: ', {
                xjpjData: this.xjpjData,
                ztpjData: this.ztpjData,
                zgpjdata: this.zgpjdata,
                modelList: this.modelList
            });
            const choicedModelList = this.modelList.filter((item) => !!item);
            console.log('choicedModelList: ', choicedModelList);
            if (this.xjpjData.length > choicedModelList.length) {
                Toast.fail('请填写完整细节评价');
                return false;
            }
            const ztpjData = this.ztpjData.some((item) => {
                return item.value !== '' && item.number !== undefined && item.number !== '';
            });
            const zgpjdata = this.zgpjdata.some((item) => {
                return item.dpjnr === '';
            });
            if (!ztpjData && this.ztpjFlag) {
                Toast.fail('请填写完整总体评价');
                return false;
            } else if (zgpjdata) {
                Toast.fail('请填写完整主观评价');
                return false;
            }
            const obj = {
                jg0101id: this.dataList.jg0101id,
                jx0404id: this.dataList.jx0404id,
                kcdldm: this.dataList.kcdldm,
                kcmc: this.dataList.kcmc,
                kcsj: this.dataList.kcsj,
                pjflId: this.flId,
                xjpjData: this.xjpjData,
                xjpjpf: this.numresult,
                zc: this.dataList.zc,
                zgpjdata: this.zgpjdata,
                ztpf: this.total,
                ztpjData: this.ztpjData,
                zxs: this.dataList.zxs
            };
            console.log('xjpj', this.xjpjData);
            console.log('model', this.modelList);
            const res = await Api.xsgcpjSave(obj);
            if (res.Msg == '成功') {
                this.$router.go(-1);
            }
        }
    }
};
</script>

<style scoped lang="less">
.conten {
    margin-top: 60px;
    margin-left: 24px;
}

.conten p {
    padding: 5px 0;
}

.zongti {
    margin-top: 20px;
    margin-left: 24px;
}

.box {
    background-color: #dfe0e6;
    margin-top: 10px;
}

.zongti span {
    font-size: 20px;
    color: #000000;
    font-weight: 600;
}

.xijie {
    margin-top: 20px;
    margin-left: 24px;
}

.xijie span {
    font-size: 20px;
    color: #000000;
    font-weight: 600;
}

.xjinfo {
    background-color: #dfe0e6;
    margin-top: 10px;
    padding: 15px 0;
}

.tongji {
    margin-top: 20px;
    margin-left: 24px;
}

.tongji > span {
    font-size: 20px;
    color: #000000;
    font-weight: 600;
}

.zonghe {
    background-color: #dfe0e6;
    margin-top: 10px;
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding: 10px 0;
    display: flex;
    justify-content: space-around;
}
.van-radio__label {
    display: flex;
}

.van-field {
    border: 1px solid #dfe0e6;
}

.van-radio {
    margin: 10px;
}

.box {
    display: flex;
    padding: 15px 0;
}

.ztright {
    display: flex;
    flex-direction: column;
}

.ztright input {
    width: 110px;
    height: 27px;
    margin: 0 0 3px 0;
    border: 1px solid #000000;
}

.yijian {
    margin-top: 20px;
    margin-left: 24px;
}

.yijian > span {
    font-size: 20px;
    color: #000000;
    font-weight: 600;
}

.yijian > .van-field {
    margin-top: 10px;
}

.bottomButton {
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
}
.bottomButton > button {
    width: 50px;
    height: 50px;
    margin: 10px;
    background-color: #7469f8;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/studentEvaluation/index.vue